module.exports = __webpack_public_path__ + "static/media/3.d0e9e3c6.jpg";